export default "__VITE_ASSET__d3c138b7__"